import $http from "../../axios";
import { Notification } from "element-ui";

function notifyError(error, defaultMessage) {
    let message = defaultMessage;

    if (error.response && error.response.data && error.response.data.message) {
        message = error.response.data.message;
    }

    Notification.error({
        title: "Error!",
        message,
        type: "error",
        duration: 3000,
        customClass: "notification-box"
    });
}

export async function fetchInspectionReport({ commit }, params) {
    await $http
        .get("/api/informe-inspecciones", { params })
        .then(response => {
            commit("setInspectionList", response.data.data);
        })
        .catch(error => {
            notifyError(error, "Error al consultar el informe de inspecciones");
        });
}

export async function fetchInspectionByDocumentId({}, documentId) {
    return await $http
        .get(`/api/informe-inspecciones/${documentId}`)
        .then(response => response.data.data)
        .catch(error => {
            notifyError(error, "Error al consultar la inspección");
            return null;
        });
}



// WEBPACK FOOTER //
// ./src/modules/inspection-report/actions.js